import { TGetOrderResponse } from '@p2p/services';
import { formatCurrencyAmount } from '@p2p/shared/functions';
import QRCode from 'react-qr-code';
import { useParams } from 'react-router-dom';

import { isPayViaLinkOrder } from '../../PayByLink/payByLink.utils';
import { DeepLinkActionPay } from '../DeepLinkActionPay';
import { getPathToRedirect } from '../Sber.utils';
import { useDeepLink } from '../useDeepLink';
import styles from './DeepLinkDesktop.module.scss';

type DeepLinkDesktopProps = {
  order: TGetOrderResponse;
};

export const DeepLinkDesktop = ({ order }: DeepLinkDesktopProps) => {
  const { bankId } = useParams<{ bankId: string }>();
  const { isSber, isTinkoff, isRmFlow, rmFlowLink } = useDeepLink({ order });
  const pathToRedirect = isRmFlow ? rmFlowLink : getPathToRedirect(order.id, Number(bankId));

  const isSupported = isSber || isTinkoff || isRmFlow;

  // P2P-2890: у заявок с оплатой по ссылке провайдера (PayByLink) банковский
  // диплинк не показываем — см. isPayViaLinkOrder.
  if (!isSupported || isPayViaLinkOrder(order)) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>
        <DeepLinkActionPay />
        <h4 className={styles.header}>Быстрая оплата</h4>
        <p className={styles.description}>
          Перейдите в приложение и переведите точную сумму
          <span className={styles.price}>{formatCurrencyAmount(order.expected_income)} RUB</span>
          одним платежом
        </p>
      </div>
      <div className={styles.rightContainer}>
        <QRCode value={pathToRedirect} className={styles.qrCode} />
      </div>
    </div>
  );
};
